/**
 * The upper collapsible control has to toggle its label to "hide" or "show" depending on the visibility status of the toggled
 * element. This is also possible via bootstrap only, by making the label a collapsible element. Problem then is, that
 * during the collapse animation, both labels are shown. This class fixes that by not using an animation.
 */
KMVP.collapsibleDescription = {

    _toggleControls: function(ev) {
        var $component = $(ev.target).closest('.js-collapsible-description');
        $component.find('.js-collapsible-collapse').toggle();
        $component.find('.js-collapsible-expand').toggle();
    },

    bindEvents: function() {
        var $collapsibleTarget = $('.js-collapsible-part');
        $collapsibleTarget.on('shown.bs.collapse hidden.bs.collapse', KMVP.collapsibleDescription._toggleControls);
    }
};

$(document).ready(function () {
    KMVP.collapsibleDescription.bindEvents();
});
